
export const config = {
  strapiAPi: "https://standard-api.standarddemo.ca"//"https://standard.nbtdemo.com/",
  // http://143.244.137.145:5000/ http://localhost:1337
};
